import { useNavigate } from "react-router-dom";

const RescheduleTrigger = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    const encryptedId = "eyJpdiI6IjgyYUxFT01WbUpFeC8zSFlkMEtLZ1E9PSIsInZhbHVlIjoibUN2ZkFsUEZOQ0kvVjlmMUlPeDc2QT09IiwibWFjIjoiZmEzY2Q1MDI0MDBmMDZhNmY3NTYyNjg5ZmE0OGNlOTk0Njk5YjZjZWNlNzk0MTg2NWViMWI1ODU2NmQ4ZjEyMCIsInRhZyI6IiJ9";
    navigate(`/view-appointment/${encryptedId}`);
  };

  return (
    <div>
      <h1>Test Reschedule Trigger</h1>
      <button onClick={handleClick}>Go to Reschedule Page with Encrypted ID</button>
    </div>
  );
};

export default RescheduleTrigger;
